<template>
    <v-card class="review-card mb-4 pa-4" outlined>
        <v-card-title class="pa-0 pb-2">
            <v-avatar size="48" class="mr-3" color="grey lighten-2">
                <v-img v-if="review.user && review.user.image_url" :src="review.user.image_url">
                    <template v-slot:placeholder>
                        <v-icon>mdi-account</v-icon>
                    </template>
                </v-img>
                <v-icon v-else>mdi-account</v-icon>
            </v-avatar>
            <div class="reviewer-info">
                <span class="reviewer-name font-weight-bold">{{ review.user ? review.user.name : 'Anonymous' }}</span>
                <div class="d-flex align-center">
                    <RatingStars :value="review.rating" :readonly="true" :size="16" />
                    <span class="review-date ml-2 grey--text">{{ formatDate(review.created_at) }}</span>
                </div>
            </div>
        </v-card-title>

        <v-card-text class="pa-0 pt-2">
            <p class="review-content mb-0">{{ review.review_text }}</p>
        </v-card-text>

        <div v-if="review.response" class="manager-response mt-4 pa-3" style="background-color: #f5f5f5; border-radius: 8px;">
            <p class="font-weight-bold mb-1">
                <v-icon size="18" class="mr-1">mdi-reply</v-icon>
                Response from Property Manager
            </p>
            <p class="mb-0">{{ review.response.response_text }}</p>
            <span class="grey--text caption">{{ formatDate(review.response.created_at) }}</span>
        </div>

        <v-card-actions class="pa-0 pt-3">
            <span class="grey--text mr-2 text-caption">Was this helpful?</span>
            <v-btn
                text
                small
                :color="hasVoted ? 'primary' : 'grey'"
                @click="handleVote"
                :disabled="!isUserLoggedIn"
            >
                <v-icon left small>mdi-thumb-up-outline</v-icon>
                Yes ({{ review.helpful_count || 0 }})
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import RatingStars from '../RatingStars.vue';

export default {
    name: 'ReviewCard',
    components: {
        RatingStars
    },
    props: {
        review: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            hasVoted: false
        }
    },
    computed: {
        isUserLoggedIn() {
            return this.$store.getters.isUserLoggedIn;
        }
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            const options = { year: 'numeric', month: 'short', day: 'numeric' };
            return date.toLocaleDateString('en-US', options);
        },
        handleVote() {
            this.hasVoted = !this.hasVoted;
            this.$emit('vote', { reviewId: this.review.id });
        }
    }
}
</script>

<style scoped>
.review-card {
    border-radius: 8px;
}
.reviewer-name {
    display: block;
    font-size: 16px;
}
.review-date {
    font-size: 12px;
}
.review-content {
    line-height: 1.6;
    white-space: pre-wrap;
}
.manager-response p {
    line-height: 1.5;
}
</style>
